import AdminGuard from "helpers/AuthType/AdminGuard";
import React, { useEffect, useState } from "react";
import Select from 'react-select';
import { ToastContainer } from "react-toastify";
import {
    Card,
    Col,
    Container,
    Row,
    CardBody,
    CardTitle,
    Label,
    Input,
    Button
} from "reactstrap";
import { addAgentApi, AddDeveloper, getAllProperties, getcities } from "service/api";

const defaultValue = {
    dev_name: '',
    operating_since: '',
    total_projects: '',
    ready_projects: '',
    under_construction: '',
    operating_cities: '',
    experince: '',
    property_types: '',
    office_Address: '',
    completed_projects: '',
    ongoing_projects: '',
    about: '',
    vision: '',
    mission: '',
    company_values: '',
    logo: '',
}

const Add_builders = () => {
    const [Developer, setDeveloper] = useState(defaultValue);
    const [Area, setArea] = useState([]);
    const [Property, setProperty] = useState([]);
    const [Cities, setCities] = useState([]);
    const [previewImage, setPreviewImage] = useState(null);


    // const onValueChange = (e) => {
    //     const { name, value, files } = e.target;
    //     if (name === "logo" && files.length > 0) {
    //         const file = files[0];
    //         const reader = new FileReader();
    //         reader.onloadend = () => {
    //             setDeveloper({ ...Developer, logo: reader.result }); // base64 string
    //         };
    //         reader.readAsDataURL(file);
    //         setPreviewImage(URL.createObjectURL(file)); // preview
    //     } else {
    //         setDeveloper({ ...Developer, [name]: value });
    //     }
    // };

    const onValueChange = (e) => {
        const { name, value, files } = e.target;
        if (name === "logo" && files.length > 0) {
            const file = files[0];
            setDeveloper({ ...Developer, logo: file });
            setPreviewImage(URL.createObjectURL(file));
        } else {
            setDeveloper({ ...Developer, [name]: value });
        }
    };

    useEffect(() => {
        getProperty();
        getCities();
    }, []);

    const getProperty = async () => {
        let response = await getAllProperties();
        setProperty(response.properties);
        // console.log(response.data);
    }
    const getCities = async () => {
        let response = await getcities();
        setCities(response.data);
        // console.log(response.data);
    }

    const AddDeveloperDetails = async (e) => {
        e.preventDefault();

        const formData = new FormData();

        // Append text fields
        Object.keys(Developer).forEach(key => {
            if (
                Array.isArray(Developer[key])
            ) {
                formData.append(key, Developer[key].join(","));
            } else {
                formData.append(key, Developer[key]);
            }
        });

        try {
            const res = await AddDeveloper(formData); // this should call axios with FormData
            if (res.success) {
                toast.success("Developer added successfully!");
                setDeveloper(defaultValue);
            } else {
                toast.error(res.message || "Failed to add developer.");
            }
        } catch (err) {
            console.error(err);
            toast.error("Something went wrong!");
        }
    };


    // const AddDeveloperDetails = async (e) => {
    //     e.preventDefault();

    //     const payload = {
    //         ...Developer,
    //         operating_cities: Developer.operating_cities.join(","), // convert to "2"
    //         completed_projects: Developer.completed_projects.join(","), // convert to "6"
    //         ongoing_projects: Developer.ongoing_projects.join(","), // convert to "26"
    //     };
    //     try {
    //         const res = await AddDeveloper(payload);
    //         if (res.success) {
    //             toast.success("Developer added successfully!");
    //             setDeveloper(defaultValue);
    //         } else {
    //             toast.error(res.message || "Failed to add developer.");
    //         }
    //     } catch (err) {
    //         console.error(err);
    //         toast.error("Something went wrong!");
    //     }
    // };




    // Convert property array to options
    const propertyOptions = Property.map((property) => ({
        value: property.id,
        label: property.title
    }));
    const cityOptions = Cities.map((cities) => ({
        value: cities.id,
        label: cities.city
    }));

    // Handle multi-select change
    const handleCompletedProjectsChange = (selectedOptions) => {
        setDeveloper({
            ...Developer,
            completed_projects: selectedOptions.map(option => option.value) // Only store IDs
        });
    };

    const handleOngoingProjectsChange = (selectedOptions) => {
        setDeveloper({
            ...Developer,
            ongoing_projects: selectedOptions.map(option => option.value)
        });
    };
    const handleCompletedCitiesChange = (selectedOptions) => {
        setDeveloper({
            ...Developer,
            operating_cities: selectedOptions.map(option => option.value)
        });
    };

    //meta title
    document.title = "Add Developer | Form";
    <ToastContainer position="top-right" autoClose={3000} hideProgressBar={false} newestOnTop />

    return (
        <AdminGuard>
            <React.Fragment>
                <div className="page-content" style={{ color: "#fff", fontFamily: "'Roboto', sans-serif" }}>
                    <Container fluid={true} className="py-1">
                        <Row className="justify-content-center">
                            <Col xl={12} lg={12} md={12}>
                                <Card style={{ backgroundColor: '#1E253A' }}>
                                    <CardBody>
                                        <CardTitle className="h3">Add Developer</CardTitle>
                                        <form encType="multipart/form-data">
                                            <Row>
                                                <Col md={3}>
                                                    <div className="mb-3">
                                                        <Label htmlFor="formrow-country-Input">Developer/Group Name</Label>
                                                        <Input type="text" className="form-control" name="dev_name" placeholder="Developer/Group Name" onChange={(e) => onValueChange(e)} />
                                                    </div>
                                                </Col>
                                                <Col md={3}>
                                                    <div className="mb-3">
                                                        <Label htmlFor="formrow-squantity-Input">Operating Since</Label>
                                                        <Input type="text" className="form-control" name="operating_since" placeholder="Operating Since Which Year" onChange={(e) => onValueChange(e)} />
                                                    </div>
                                                </Col>
                                                <Col md={3}>
                                                    <div className="mb-3">
                                                        <Label htmlFor="formrow-squantity-Input">Total Projects</Label>
                                                        <Input type="text" className="form-control" name="total_projects" placeholder="No. Of Total Projects" onChange={(e) => onValueChange(e)} />
                                                    </div>
                                                </Col>
                                                <Col md={3}>
                                                    <div className="mb-3">
                                                        <Label htmlFor="formrow-squantity-Input">Ready To Move Projects</Label>
                                                        <Input type="text" className="form-control" name="ready_projects" placeholder="No. of projects ready to move" onChange={(e) => onValueChange(e)} />
                                                    </div>
                                                </Col>
                                                <Col md={4}>
                                                    <div className="mb-3">
                                                        <Label htmlFor="formrow-squantity-Input">Total Under Construction Projects</Label>
                                                        <Input type="text" className="form-control" name="under_construction" placeholder="No, Of Total Under Construction Projects" onChange={(e) => onValueChange(e)} />
                                                    </div>
                                                </Col>
                                                <Col md={4}>

                                                    <div className="mb-3">
                                                        <Label>Select City</Label>
                                                        <Select
                                                            isMulti
                                                            options={cityOptions}
                                                            onChange={handleCompletedCitiesChange}
                                                            placeholder="Select City"
                                                            styles={{
                                                                control: (base) => ({
                                                                    ...base,
                                                                    backgroundColor: '#fff',
                                                                    color: '#000',
                                                                }),
                                                                input: (base) => ({
                                                                    ...base,
                                                                    color: '#000',
                                                                }),
                                                                placeholder: (base) => ({
                                                                    ...base,
                                                                    color: '#000',
                                                                }),
                                                                singleValue: (base) => ({
                                                                    ...base,
                                                                    color: '#000',
                                                                }),
                                                                menu: (base) => ({
                                                                    ...base,
                                                                    backgroundColor: '#fff',
                                                                }),
                                                                option: (base, state) => ({
                                                                    ...base,
                                                                    backgroundColor: state.isFocused ? '#f0f0f0' : '#fff',
                                                                    color: '#000',
                                                                }),
                                                                multiValueLabel: (base) => ({
                                                                    ...base,
                                                                    color: '#000',
                                                                }),
                                                            }}
                                                        />
                                                    </div>
                                                </Col>
                                                <Col md={4}>
                                                    <div className="mb-3">
                                                        <Label htmlFor="formrow-squantity-Input">Experince</Label>
                                                        <Input type="text" className="form-control" name="experince" placeholder="How many years of experience" onChange={(e) => onValueChange(e)} />
                                                    </div>
                                                </Col>
                                                <Col md={4}>
                                                    <div className="mb-3">
                                                        <Label htmlFor="formrow-login">Property Types</Label>
                                                        <select name="property_types" className="form-control" onChange={(e) => onValueChange(e)}>
                                                            <option defaultValue>Choose...</option>
                                                            <option>Resedential</option>
                                                            <option>Comercial</option>
                                                        </select>
                                                    </div>
                                                </Col>

                                                <Col md={4}>
                                                    <div className="mb-3">
                                                        <Label>Select Completed Projects</Label>
                                                        <Select
                                                            isMulti
                                                            options={propertyOptions}
                                                            onChange={handleCompletedProjectsChange}
                                                            placeholder="Select Completed Projects"
                                                            styles={{
                                                                control: (base) => ({
                                                                    ...base,
                                                                    backgroundColor: '#fff',
                                                                    color: '#000',
                                                                }),
                                                                input: (base) => ({
                                                                    ...base,
                                                                    color: '#000',
                                                                }),
                                                                placeholder: (base) => ({
                                                                    ...base,
                                                                    color: '#000',
                                                                }),
                                                                singleValue: (base) => ({
                                                                    ...base,
                                                                    color: '#000',
                                                                }),
                                                                menu: (base) => ({
                                                                    ...base,
                                                                    backgroundColor: '#fff',
                                                                }),
                                                                option: (base, state) => ({
                                                                    ...base,
                                                                    backgroundColor: state.isFocused ? '#f0f0f0' : '#fff',
                                                                    color: '#000',
                                                                }),
                                                                multiValueLabel: (base) => ({
                                                                    ...base,
                                                                    color: '#000',
                                                                }),
                                                            }}
                                                        />
                                                    </div>
                                                </Col>

                                                <Col md={4}>
                                                    <div className="mb-3">
                                                        <Label>Select Ongoing Projects</Label>
                                                        <Select
                                                            isMulti
                                                            options={propertyOptions}
                                                            onChange={handleOngoingProjectsChange}
                                                            placeholder="Select Ongoing Projects"
                                                            styles={{
                                                                control: (base) => ({
                                                                    ...base,
                                                                    backgroundColor: '#fff',
                                                                    color: '#000',
                                                                }),
                                                                input: (base) => ({
                                                                    ...base,
                                                                    color: '#000',
                                                                }),
                                                                placeholder: (base) => ({
                                                                    ...base,
                                                                    color: '#000',
                                                                }),
                                                                singleValue: (base) => ({
                                                                    ...base,
                                                                    color: '#000',
                                                                }),
                                                                menu: (base) => ({
                                                                    ...base,
                                                                    backgroundColor: '#fff',
                                                                }),
                                                                option: (base, state) => ({
                                                                    ...base,
                                                                    backgroundColor: state.isFocused ? '#f0f0f0' : '#fff',
                                                                    color: '#000',
                                                                }),
                                                                multiValueLabel: (base) => ({
                                                                    ...base,
                                                                    color: '#000',
                                                                }),
                                                            }}
                                                        />
                                                    </div>
                                                </Col>
                                                <Col md={4}>
                                                    <div className="mb-3">
                                                        <Label htmlFor="formrow-squantity-Input">Office Address</Label>
                                                        <textarea type="text" className="form-control" name="office_Address" placeholder="Office Address" onChange={(e) => onValueChange(e)} />
                                                    </div>
                                                </Col>
                                                <Col md={4}>
                                                    <div className="mb-3">
                                                        <Label htmlFor="formrow-squantity-Input">About You</Label>
                                                        <textarea type="text" className="form-control" name="about" placeholder="Describe Your Self" onChange={(e) => onValueChange(e)} />
                                                    </div>
                                                </Col>
                                                <Col md={4}>
                                                    <div className="mb-3">
                                                        <Label htmlFor="formrow-squantity-Input">Vision</Label>
                                                        <textarea type="text" className="form-control" name="vision" placeholder="Vision" onChange={(e) => onValueChange(e)} />
                                                    </div>
                                                </Col>
                                                <Col md={4}>
                                                    <div className="mb-3">
                                                        <Label htmlFor="formrow-squantity-Input">Mission</Label>
                                                        <textarea type="text" className="form-control" name="mission" placeholder="Mission" onChange={(e) => onValueChange(e)} />
                                                    </div>
                                                </Col>
                                                <Col md={4}>
                                                    <div className="mb-3">
                                                        <Label htmlFor="formrow-squantity-Input">Values</Label>
                                                        <textarea type="text" className="form-control" name="company_values" placeholder="Values" onChange={(e) => onValueChange(e)} />
                                                    </div>
                                                </Col>
                                                <Col md={4}>
                                                    <div className="mb-3">
                                                        <Label>Upload Image/Logo</Label>
                                                        <Input
                                                            type="file"
                                                            accept="image/*"
                                                            name="logo"
                                                            className="form-control"
                                                            onChange={onValueChange}
                                                        />
                                                        {previewImage && (
                                                            <img
                                                                src={previewImage}
                                                                alt="Logo Preview"
                                                                style={{ marginTop: "10px", maxHeight: "100px", borderRadius: "5px" }}
                                                            />
                                                        )}
                                                    </div>
                                                </Col>

                                            </Row>
                                            <div className="d-flex justify-content-end">
                                                <button
                                                    className="btn btn-success w-md"
                                                    onClick={(e) => AddDeveloperDetails(e)}
                                                >
                                                    Save
                                                </button>
                                            </div>

                                        </form>
                                    </CardBody>
                                </Card>
                            </Col>
                        </Row>
                    </Container>
                </div>
            </React.Fragment>
        </AdminGuard>
    )
}

export default Add_builders
